import React, { useState,useEffect } from 'react';



const GameWeek = ({ AuthService, UserService,selection }) => {




  return (
    
<div className="body main-layout-item game_week ColumnSection_list_one">
<div className="Home_root">
   <div className="Home_games">
      <div className="HomeSectionCasinoGames_list">
         <div className="HomeSectionCasinoGames_game">
            <div className="CasinoGameCard_root">
               <div className="CasinoGamePreview_root">
                  <div className="CasinoGamePreview_gradient"></div>
                  <img className="ResponsivePicture_img   CasinoGamePreview_image" src="https://storage.googleapis.com/camasy-images/casino/pragmatic__play__live__63d3ec69db799.png" loading="lazy"/>
               </div>
               <div className="title-boxGameWeek">
                  <div className="gameWeek-provider">
                     <img alt="Ezugi" src="https://v1.bundlecdn.com/img/ezugi.a9c66babd.svg" className="CasinoGameCard_icon"/>
                     <p>Ezugi</p>
                  </div>
                  <div className="gameWeek-name">
                     <small>Gioco della settimana</small><br/>
                     Nome del giocoanche lungo
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</div>
</div>

  );
};


export default GameWeek;













